// Copyright (C) 2019 TANNER AG

import React from "react";
import * as PropTypes from "prop-types";
import classnames from "classnames";
import { withStyles } from "@material-ui/core/styles"
import MaterialButton from "@material-ui/core/Button"

const buttonStyles = theme => ({
	root: {
		fontFamily: "MAN-Light, Arial, sans-serif",
		borderRadius: "6px",
		textTransform: "none",
		fontWeight: 300,
		padding: "10px 16px"
	},
	contained: {
		backgroundColor: "#e40045",
		color: "#fff",
		"&:hover": {
			backgroundColor: "#b10036"
		},
		"&:disabled": {
			backgroundColor: "#e40045",
			color: "#fff",
			opacity: "0.1"
		}
	},
	containedPrimary: {
		backgroundColor: "#303c49",
		color: "#fff",
		"&:hover": {
			backgroundColor: "rgb(48,60,73, .8)"
		},
	},
	outlined: {
		borderColor: "#303c49",
		backgroundColor: "#fff",
		color: "#303c49",
		"&:disabled": {
			color: "#303c49",
			opacity: "0.1"
		}
	},
	sizeLarge: {
		fontSize: "22px",
		lineHeight: "21px",
		padding: "18px 25px"
	}
});

export const Button = withStyles(buttonStyles)((props) => {
	const { classes, component, children, ...others } = props;
	return (
		<MaterialButton
			classes={classes}
			component={component}
			{...others}
		>
			{children}
		</MaterialButton>
	);
});

Button.propTypes = {
	classes: PropTypes.object,
	children: PropTypes.any,
	component: PropTypes.any
};

Button.defaultProps = {
	component: "button"
};

const tileStyles = theme => ({
	button: {
		fontFamily: "MAN-Light, Arial, sans-serif",
		backgroundColor: "#fff",
		borderRadius: "0",
		boxShadow: "0 2px 4px 0 #E2E3E4",
		textTransform: "none",
		fontSize: "15px",
		fontWeight: 300,
		lineHeight: "22px",
		padding: "14px 14px"
	},
	active: {
		backgroundColor: "#e40045",
		color: "#fff",
		"&:hover": {
			backgroundColor: "#b10036"
		},
	}
});

export const TileButton = withStyles(tileStyles)((props) => {
	const { classes, component, active, children, ...others } = props;
	return (
		<MaterialButton
			classes={{ root: classnames(classes.button, { [classes.active]: active }) }}
			component={component}
			size="large"
			{...others}
		>
			{children}
		</MaterialButton>
	);
});

TileButton.propTypes = {
	classes: PropTypes.object,
	children: PropTypes.any,
	component: PropTypes.any,
	active: PropTypes.bool
};

TileButton.defaultProps = {
	component: "button",
	active: false
};



// WEBPACK FOOTER //
// ./src/tco/components/button.js